import * as R from 'ramda'

const getCategoryListing = (state: any) => R.pathOr({}, ['UserManagement', 'categoryListingData'], state);
const checkAppPermission = (state: any) => R.pathOr(true, ["UserManagement", "checkAppPermission"], state);
const isCheckAppPer = (state: any) => R.pathOr(true, ["UserManagement", "isCheckAppPer"], state);
const addAppPerVal = (state: any) => R.pathOr(0, ["UserManagement", "addAppPerVal"], state);
const addSecurityRoleVal = (state: any) => R.pathOr(0, ["UserManagement", "addSecurityRoleVal"], state);
const getApplicationListing = (state: any) => R.pathOr({}, ['UserManagement', 'applicationListingData'], state);
const getAppAreaListing = (state: any) => R.pathOr({}, ['UserManagement', 'appAreaListingData'], state);
const getActiveCategory = (state: any) => R.pathOr({}, ['UserManagement', 'activeCategory'], state);
const checkCategory = (state: any) => R.pathOr(true, ["UserManagement", "checkCategory"], state);
const isCategoryCheck = (state: any) => R.pathOr(true, ["UserManagement", "isCategoryCheck"], state);
const isCheck = (state: any) => R.pathOr(true, ["UserManagement", "isCheck"], state);
const addCategoryVal = (state: any) => R.pathOr(0, ["UserManagement", "addCategoryVal"], state);
const appPermissionListing = (state: any) => R.pathOr({}, ['UserManagement', 'appPermissionListing'], state);
const appPermissionById = (state: any) => R.pathOr({}, ['UserManagement', 'appPermissionById'], state);
const securityRoleById = (state: any) => R.pathOr({}, ['UserManagement', 'securityRoleById'], state);
const deleteAppPermission = (state: any) => R.pathOr(false, ['UserManagement', 'deleteAppPermission'], state);
const deleteSecurityRole = (state: any) => R.pathOr(false, ['UserManagement', 'deleteSecurityRole'], state);
const checkAppArea = (state: any) => R.pathOr(true, ["UserManagement", "checkAppArea"], state);
const isAppAreaCheck = (state: any) => R.pathOr(true, ["UserManagement", "isAppAreaCheck"], state);
const getaddAppAreaVal = (state: any) => R.pathOr(0, ["UserManagement", "addAppAreaVal"], state);
const appAreaById = (state: any) => R.pathOr({}, ['UserManagement', 'appAreaById'], state);
const deleteAppArea = (state: any) => R.pathOr(false, ['UserManagement', 'deleteAppArea'], state);
const checkApplication = (state: any) => R.pathOr(true, ["UserManagement", "checkApplication"], state);
const isApplicationCheck = (state: any) => R.pathOr(true, ["UserManagement", "isApplicationCheck"], state);
const getaddApplicationVal = (state: any) => R.pathOr(0, ["UserManagement", "getaddApplicationVal"], state);
const deleteCategory = (state: any) => R.pathOr(false, ['UserManagement', 'deleteCategory'], state);
const categoryById = (state: any) => R.pathOr({}, ['UserManagement', 'categoryById'], state);
const getActiveApplication = (state: any) => R.pathOr({}, ['UserManagement', 'activeApplication'], state);
const getActiveAppArea = (state: any) => R.pathOr({}, ['UserManagement', 'activeAppArea'], state);
const applicationById = (state: any) => R.pathOr({}, ['UserManagement', 'applicationById'], state);
const deleteApplication = (state: any) => R.pathOr(false, ['UserManagement', 'deleteApplication'], state);
const getUserGridData = (state: any) => R.pathOr({ count: 0, data: [] }, ["UserManagement", "userGridData"], state);
const getUser = (state: any) => R.pathOr({}, ['UserManagement', 'userData'], state);
const getUserUpnData = (state: any) => R.pathOr({}, ["UserManagement", "userUpnData"], state);
const getaddUserVal = (state: any) => R.pathOr(0, ["UserManagement", "getaddUserVal"], state);
const getSecurityPermissionList = (state: any) => R.pathOr({}, ['UserManagement', 'securityPermissionList'], state);
const getSecurityRoleList = (state: any) => R.pathOr({}, ['UserManagement', 'securityRoleList'], state);
const getActiveRoles = (state: any) => R.pathOr({}, ['UserManagement', 'activeRoles'], state);
const getUserDivisions = (state: any) => R.pathOr({}, ['UserManagement', 'userDivisions'], state);
const costcenterDropdown = (state: any) => R.pathOr({}, ['UserManagement', 'costcenterDropdown'], state);
const checkUser = (state: any) => R.pathOr(true, ["UserManagement", "checkUser"], state);
const isUserCheck = (state: any) => R.pathOr(true, ["UserManagement", "isUserCheck"], state);
const getTimeZone = (state: any) => R.pathOr({}, ['UserManagement', 'timeZone'], state);

const selectors = {
    getCategoryListing,
    checkAppPermission,
    getApplicationListing,
    getAppAreaListing,
    addAppPerVal,
    isCheckAppPer,
    getActiveCategory,
    isCategoryCheck,
    checkCategory,
    addCategoryVal,
    appPermissionListing,
    appPermissionById,
    securityRoleById,
    deleteAppPermission,
    deleteSecurityRole,
    checkAppArea,
    isAppAreaCheck,
    getaddAppAreaVal,
    appAreaById,
    deleteAppArea,
    checkApplication,
    isApplicationCheck,
    getaddApplicationVal,
    deleteCategory,
    categoryById,
    getActiveApplication,
    getActiveAppArea,
    applicationById,
    deleteApplication,
    isCheck,
    getUserGridData,
    getUser,
    getSecurityPermissionList,
    getSecurityRoleList,
    getActiveRoles,
    getaddUserVal,
    addSecurityRoleVal,
    getUserUpnData,
    getUserDivisions,
    costcenterDropdown,
    checkUser,
    isUserCheck,
    getTimeZone
}

export default selectors